import { create } from 'zustand'

export interface StorylineState {
  baseCptIds: string[]
  chapters: string[][]

  toggleBaseCpt: (id: string) => void
  setBaseCptIds: (ids: string[]) => void
  removeBaseCpt: (id: string) => void

  addChapter: () => void
  removeChapter: (index: number) => void
  updateChapter: (index: number, ids: string[]) => void
  setChapters: (chapters: string[][]) => void

  removeCptFromChapter: (chapterIndex: number, cptId: string) => void

  reset: () => void
}

const initialState = {
  baseCptIds: [] as string[],
  chapters: [] as string[][],
}

export const useStorylineStore = create<StorylineState>((set) => ({
  ...initialState,

  toggleBaseCpt: (id) =>
    set((s) => ({
      baseCptIds: s.baseCptIds.includes(id)
        ? s.baseCptIds.filter((cid) => cid !== id)
        : [...s.baseCptIds, id],
    })),

  setBaseCptIds: (ids) => set({ baseCptIds: ids }),

  removeBaseCpt: (id) =>
    set((s) => ({ baseCptIds: s.baseCptIds.filter((cid) => cid !== id) })),

  addChapter: () =>
    set((s) => ({ chapters: [...s.chapters, []] })),

  removeChapter: (index) =>
    set((s) => ({
      chapters: s.chapters.filter((_, i) => i !== index),
    })),

  updateChapter: (index, ids) =>
    set((s) => ({
      chapters: s.chapters.map((ch, i) => (i === index ? ids : ch)),
    })),

  setChapters: (chapters) => set({ chapters }),

  removeCptFromChapter: (chapterIndex, cptId) =>
    set((s) => ({
      chapters: s.chapters.map((ch, i) =>
        i === chapterIndex ? ch.filter((id) => id !== cptId) : ch,
      ),
    })),

  reset: () => set(initialState),
}))
